
import dayjs from '@/plugins/dayjs'

import * as echarts from "echarts";
import "echarts-gl";
import '@/common/china';

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getPageAPIs, get3DPieOption, getChinaMapEchartOption } from "@/common/util";
import { DataStatisticRecordAPI } from "@/common/api/dataWholeBoard/businessStatisticEcharts";
// import { util } from "vue/types/umd";
import { DeepLoop } from "@/common/deepLoop/deepLoop";

import { CommonApi } from "@/common/api/common";

import { shareConfirmOptions, shareShopType2ch, getCommonList } from "@/common/config";

export const pageApiList = getPageAPIs(DataStatisticRecordAPI);

// 类型 1今天  2昨天  3本月
const channelRadioTimeRange2ch = ['', '今天', '昨天', '本月']

const defaultChannelRadioTimeRange = {
  label: '',
  value: ''
}

@Component({
  filters: {},
})
export default class BusinessStatisticEchartsRecord extends Vue {
  private dataStatisticApi: any;

 

  private deepLoopUtil: any;
  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.dataStatisticApi = new DataStatisticRecordAPI();

    // this.initChannelChannelRadioTimeRangeInfo()

    this.curChannelRadioTimeRange = {
      ...this.deepLoopUtil.deepCopy(defaultChannelRadioTimeRange, false),
    }
  }

  // private dataBoardList: any[] = [
  //   // ...(dataBoardList || [])
  // ];

  private todayDate: string = ''

  private refreshBoardInfo() {
    this.todayDate = dayjs().format('YYYY.MM.DD')

    this.dataStatisticApi.getDataTotalRecords(
      {},
      (res: any) => {
        const {
          month_new_group = 0,
          plane_figure_wait_confirm,
          plane_shop_construction,
          confirm_site_not_open,

          data_board,
          map,
          graph = [],

          pool_room_distribute_total,
          desk_num = 0,
          open_num = 0
        } = res.data || {};

        // debug
        // const graph = [
        //   {
        //     date: '2025-03',
        //     child: [
        //       {
        //         name: 'GMV>1万',
        //         value: 1,
        //       },
        //       {
        //         name: 'GMV>3万',
        //         value: 2,
        //       },
        //       {
        //         name: 'GMV>5万',
        //         value: 3,
        //       }
        //     ]
        //   },
        //   {
        //     date: '2025-04',
        //     child: [
        //       {
        //         name: 'GMV>1万',
        //         value: 4,
        //       },
        //       {
        //         name: 'GMV>3万',
        //         value: 5,
        //       },
        //       {
        //         name: 'GMV>5万',
        //         value: 6,
        //       }
        //     ]
        //   },
        //   {
        //     date: '2025-05',
        //     child: [
        //       {
        //         name: 'GMV>1万',
        //         value: 7,
        //       },
        //       {
        //         name: 'GMV>3万',
        //         value: 8,
        //       },
        //       {
        //         name: 'GMV>5万',
        //         value: 9,
        //       }
        //     ]
        //   }
        // ]

        // const {
        //   plane_figure_wait_confirm,
        //   plane_shop_construction,
        //   confirm_site_not_open,
        // } = {
        //   plane_figure_wait_confirm: 1,
        //   plane_shop_construction: 10,
        //   confirm_site_not_open: 2,
        // }

        const {
          gmv,
          platform_income,
          
        } = data_board || {}

        this.init3DPieEcharts({
          month_new_group,
          plane_figure_wait_confirm,
          plane_shop_construction,
          confirm_site_not_open,
        });
      
        this.iniGMVAndIncome({
          gmv,
          platform_income
        })

        this.initChinaMapEcharts({
          map,
          pool_room_distribute_total,
          desk_num,
          open_num
        })

        this.initGmvBarEchart({
          graph
        })
      },
      () => {}
    );

    this.initChanelRadioPieInfo()
  }

  private pie3dEchartIns: any;

  private empty3DPieEchart: boolean = false;
  private pie3dInfo: any = {
    month_new_group: 0,
  };

  private onPie3dChangeLegend: any

  private init3DPieEcharts({
    month_new_group = 0,
    plane_figure_wait_confirm,
    plane_shop_construction,
    confirm_site_not_open,
  }: any) {
    const pie3dInfo = {
      month_new_group,
    };

    const pie3dLegendOption = {
      legend: {
        orient: "vertical",
        top: 'top',
        right: "right",
        formatter: function (name: string) {
          const somePieData: any =
            pie3dData.find((eachPieData: any) => eachPieData.name == name) ||
            {};
          const value: any = somePieData.value;
          return `${name}：${value}`;
        },
      },
    }


    const pie3dData = [
      {
        name: "已确定场地但未开业>30天",
        value: confirm_site_not_open,
        itemStyle: {
          color: '#1FA6FF'
        },
      },
      {
        name: "平面图待确认时间>5天",
        value: plane_figure_wait_confirm,
        itemStyle: {
          color: '#FEB100'
        },
      },
      {
        name: "门店施工>15天",
        value: plane_shop_construction,
        itemStyle: {
          color: '#FF525A'
        },
      },
    ];

    console.log(pie3dData, "pie3dData");

    const pie3dDom: any = document.querySelector(".pie-3d-chart");
    const isFirst = !this.pie3dEchartIns
    const pie3dEchartIns = isFirst
      ? echarts.init(pie3dDom)
      : this.pie3dEchartIns;

    console.log(pie3dEchartIns, "pie3dEchartIns");

    const pie3dOption = get3DPieOption(pie3dData);

    if (
      confirm_site_not_open > 0 ||
      plane_figure_wait_confirm > 0 ||
      plane_shop_construction > 0
    ) {
      this.empty3DPieEchart = false;
      //是否需要label指引线，如果要就添加一个透明的2d饼状图并调整角度使得labelLine和3d的饼状图对齐，并再次setOption
      pie3dOption.series.push({
        backgroundColor: "transparent",
        name: "pie2d",
        type: "pie",
        top: '40px',
        label: { opacity: 1, overflow: "none" },
        itemStyle: { opacity: 0.02 },
        labelLine: { length: 40, length2: 30 },
        startAngle: -60, // 起始角度，支持范围[0, 360]。
        clockwise: false, // 饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
        radius: ["30%", "55%"],
        center: ["50%", "50%"],
        data: pie3dData, // 与之前的series数据一致
        tooltip: {
          show: false,
        },
      });
    } else {
      this.empty3DPieEchart = true;
    }

    pie3dEchartIns.setOption(
      {
        ...pie3dOption,
        ...pie3dLegendOption
      },
      true
    );

    this.pie3dEchartIns = pie3dEchartIns;

    this.pie3dInfo = pie3dInfo;

    if (isFirst) {
      this.onPie3dChangeLegend = ({ selected }: any) => {
        const pie3DOption = {
          ...get3DPieOption(pie3dData, {
            _selected: selected
          }),
          ...pie3dLegendOption
        }

        pie3dEchartIns.setOption(pie3DOption)
        
      }
      pie3dEchartIns.on('legendselectchanged', this.onPie3dChangeLegend)
    }
  }


  private gmvIncomeList: any[] = []
  private iniGMVAndIncome(gmvIncomeOp: any) {
    const itemKeys = ['today', 'month', 'year']

    const itemNames = ['今日', '本月', '全年']

    const itemClss = ['green', 'yellow', 'red']

    const list = ['gmv', 'platform_income']

    const listNames = ['GMV', '抽佣']

    // 数字超过万 添加单位
    const limitNum: number = 10000

    const gmvIncomeList = list.map((key: string, index: number) => {
      const name = listNames[index]

      const item = gmvIncomeOp[key]

      return itemKeys.map((key: string, index: number) => {
        const itemName = itemNames[index] 

        const value = item[key] > limitNum ? `${parseFloat((item[key] / limitNum).toFixed(0))}` : item[key] || 0

        const itemCls = itemClss[index]
        return {
          value: value,
          unit: item[key] > limitNum ? '万' : '',
          label: `${itemName}${name}`,
          className: itemCls
        }
      })
    }) 

    console.log(gmvIncomeList, 'gmvIncomeList')

    this.gmvIncomeList = gmvIncomeList
  }


  private chindMapEchartIns: any;

  private chinaMapInfo: any = {
    desk_num: 0,
    open_num: 0,
    shop_num: 0,
  }
  private initChinaMapEcharts({
    map = [],
    pool_room_distribute_total = 0,
    desk_num = 0,
    open_num = 0
  }) {
    const chinaMapInfo = {
      desk_num,
      open_num,
      shop_num: pool_room_distribute_total
    }


    const chinaMapChartDom: any = document.querySelector(".china-map-echart");

    const isFirst = !this.chindMapEchartIns
    const chindMapEchartIns = isFirst
      ? echarts.init(chinaMapChartDom)
      : this.chindMapEchartIns;

    console.log(chindMapEchartIns, "chindMapEchartIns");

    this.chindMapEchartIns = chindMapEchartIns

    const pinDotData = map.map((dotItem: any) => {
      const {
        lat,
        long
      } = dotItem || {}

      const newDotItem = {
        ...dotItem,
        value: [long, lat]
      }
      
      return newDotItem
    })

    const chinaMapEchartOption = getChinaMapEchartOption(pinDotData)

    chindMapEchartIns.setOption(chinaMapEchartOption)

    if (isFirst) {
      chindMapEchartIns.on('mouseover', this.onClickChinMapEachrt)
    }


    this.chinaMapInfo = chinaMapInfo
  }

  private onClickChinMapEachrt(params: any) {
    if (params.componentType == 'series') {
      // console.log(params, 'params')

      if (params.componentSubType == "effectScatter") {
        const {
          code,
          name
        } = params.data

        this.provinceGeoName = name

        this.refreshProvinceInfo(code)
      }
    }
  }

  private refreshProvinceInfo(code: number) {
    if (!code) return Promise.reject('invalid code')

    return new Promise((resolve, reject) => {
      this.dataStatisticApi.getProvinceInfo({
        province: code
      }, (res: any) => {
        const {
          list = [],
          month_new_sign_shop_num,
          month_new_unsign_shop_num,
        } = res.data || {}

        const provinceGeoInfoList = this.refreshProvinceGeoInfoList({
          list,
          month_new_sign_shop_num,month_new_unsign_shop_num
        })

        this.provinceGeoInfoList = provinceGeoInfoList

        resolve(provinceGeoInfoList)
      }, (err: any) => {
        reject(err)
      })
    })
  }

  private provinceGeoInfoList: any[] = []

  private provinceGeoName: string = ''

  private refreshProvinceGeoInfoList({
    list = [],
    month_new_sign_shop_num = 0,
    month_new_unsign_shop_num = 0
  }) {
    // 店铺状态:1开业中2对接中3暂停对接4已解约
    const shopStatus2Ch: string[] = ['', '开业中', '对接中', '暂停对接', '已解约']

    const provinceGeoInfoList: any[] = list.map((item: any) => {
      const {
        total,
        shop_status
      } = item || {}

      return {
        total,
        label: shopStatus2Ch[shop_status] || '未知'
      }
    })

    // debug
    // provinceGeoInfoList.push({
    //   label: '开业中',
    //   total: 20,
    // }, {
    //   label: '开业中',
    //   total: 20,
    // }, {
    //   label: '开业中',
    //   total: 20,
    // }, {
    //   label: '开业中',
    //   total: 20,
    // })

    provinceGeoInfoList.push({
      extra: true,
      label: '本月新增店铺',
      total: month_new_sign_shop_num
    }, {
      // extra: true,
      label: '本月解约店铺',
      total: month_new_unsign_shop_num
    })

    return provinceGeoInfoList
  }


  private gmvBarEchartIns: any

  private initGmvBarEchart({
    graph = []
  }) {
    const barXAxis = []
    const barLegend = []

    const barItemStyleColors = [
      {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(31, 166, 255, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(31, 166, 255, 0.20)' // 100% 处的颜色
        }],
        global: false // 缺省为 false
      },
      {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(0, 202, 100, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(0, 202, 100, 0.20)' // 100% 处的颜色
        }],
        global: false // 缺省为 false
      },
      {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: 'rgba(254, 177, 0, 1)' // 0% 处的颜色
        }, {
          offset: 1, color: 'rgba(254, 177, 0, 0.20)' // 100% 处的颜色
        }],
        global: false // 缺省为 false
      }
    ]

    const series = []

    for(const {date, child} of graph) {
      if (barLegend.length == 0) {
        barLegend.push(
          ...(child as any[]).map(({ name }: any) => {
            return name
          })
        )
      }

      const month = (date as any).split('-')[1]

      barXAxis.push(`${month}月`)

      if (series.length == 0) {
        series.push(
          ...(child as any[]).map(({ name, value }: any, index: number) => {
            return {
              name,
              type: 'bar',
              barGap: '.5px',
              data: [{
                date,
                value: value
              }],
              itemStyle: {
                color: barItemStyleColors[index]
              }
            }
          })
        )

        console.log(series, 'series')
      } else {
        series.forEach((serItm: any, index) => {
          serItm.data.push({
            date,
            value: (child[index] as any).value
          })
        })
      }
    }

    console.log(barXAxis, 'barXAxis')
    console.log(barLegend, 'barLegend')
    console.log(series, 'series')

    const gmvBarChartDom: any = document.querySelector(".gmv-bar-echart");

    const isFirst = !this.gmvBarEchartIns
    const gmvBarEchartIns = isFirst
      ? echarts.init(gmvBarChartDom)
      : this.gmvBarEchartIns;

    console.log(gmvBarEchartIns, "gmvBarEchartIns");

    this.gmvBarEchartIns = gmvBarEchartIns

    const gmvBarEchartOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: function(params: any) {
          let labelDate = ''

          const list = params.map((param: any) => {
            const {
              seriesName,
              data = {}
            } = param

            const {
              date,
              value
            } = data

            if (!labelDate) {
              labelDate = date
            }

            return `${seriesName}： ${value}`
          })

          

          // console.log(params, 'params')
          return `${labelDate}<br />${list.join('<br />')}`
        },
        // rich: {
        //   a: {
        //     color: 'inherit'
        //   },
        //   // c: {
        //   //   color: 'inherit'
        //   // }
        // }
      },
      legend: {
        data: barLegend
      },
      xAxis: [
        {
          type: 'category',
          axisTick: { show: false },
          data: barXAxis
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      series
    }

    gmvBarEchartIns.setOption(gmvBarEchartOption)
  }


  private channelRadioPieEchartIns: any

  private curChannelRadioTimeRange: any = {}

  private initChannelChannelRadioTimeRangeInfo() {
    const channelRadioTimeRangeList: any[] = [
      ...getCommonList(channelRadioTimeRange2ch, 1)
    ]

    console.log(channelRadioTimeRangeList, 'channelRadioTimeRangeList')

    // this.curChannelRadioTimeRange = {}

    Object.assign(this.curChannelRadioTimeRange, {
      ...(channelRadioTimeRangeList[0] || {})
    })


    this.channelRadioTimeRangeList = channelRadioTimeRangeList
  }

  private channelRadioTimeRangeList: any[] = [
    ...getCommonList(channelRadioTimeRange2ch, 1)
  ]

  

  private onChangeChannelRadioTimeRange(timeItem: any) {
    const prevChannelRadioTimeRange = this.curChannelRadioTimeRange

    if (prevChannelRadioTimeRange.value != timeItem.value) {
      Object.assign(this.curChannelRadioTimeRange, {
        ...(timeItem || {})
      })

      console.log(this.curChannelRadioTimeRange, 'this.curChannelRadioTimeRange')

      this.initChanelRadioPieInfo(false)
    }
  }

  private initChanelRadioPieInfo(fresh: boolean = true) {
    if (fresh) {
      this.initChannelChannelRadioTimeRangeInfo()
    }

    const curChannelRadioTimeRange = this.curChannelRadioTimeRange

    const params = {
      type: curChannelRadioTimeRange.value
    }

    return new Promise((resolve, reject) => {
      this.dataStatisticApi.getChannelRadioRecord(params, (res: any) => {
        const {
          business_income,
          douyin,
          meituan,
          private: privateBusiness
        } = res.data || {}

        this.initChanelRadioPieEchart({
          douyin,
          meituan,
          privateBusiness
        })
      }, (err: any) => reject(err))
    })
  }

  private initChanelRadioPieEchart({
    douyin = 0,
    meituan = 0,
    privateBusiness = 0
  }) {

    const pieData = [
      {
        name: '抖音',
        value: douyin
      },
      {
        name: '美团',
        value: meituan
      },
      {
        name: '私域',
        value: privateBusiness
      }
    ]

    const channelRadioPieChartDom: any = document.querySelector(".channel-radio-pie-ecahrt");

    const isFirst = !this.channelRadioPieEchartIns
    const channelRadioPieEchartIns = isFirst
      ? echarts.init(channelRadioPieChartDom)
      : this.channelRadioPieEchartIns;

    console.log(channelRadioPieEchartIns, "channelRadioPieEchartIns");

    this.channelRadioPieEchartIns = channelRadioPieEchartIns

    const channelRadioPieOption = {
      legend: {
        show: false,
      },
      
      label: {
        show: true,
        position: "outside",
        formatter: function (params: any) {
          // console.log(params, 'params')
          return `{b|${params.name}} {d|${params.percent.toFixed(2)}}{c|${"%"}}`;
        },
        rich: {
          d: {
            fontSize: 16,
            lineHeight: 16,
            // fontFamily: "Source Han Sans",
            fontWeight: "bold",
            color: "inherit",
          },
          b: {
            fontSize: 16,
            lineHeight: 16,
            // fontFamily: "Source Han Sans",
            fontWeight: "bold",
            color: "inherit",
          },
          c: {
            fontSize: 14,
            lineHeight: 14,
            color: "inherit",
          },
        },
      },
      series: [
        {
          type: 'pie',
          radius: '50%',
          data: pieData,
          labelLine: {
            show: true,
            showAbove: true,
            lineStyle: {
              cap: 'round'
            }
          },
        }
      ]
    }

    channelRadioPieEchartIns.setOption(channelRadioPieOption)
  }


  private resizeTimer: any = null
  private resizeEcharts() {
    clearTimeout(this.resizeTimer)

    this.resizeTimer = setTimeout(() => {
      const pie3dEchartIns = this.pie3dEchartIns

      if (pie3dEchartIns) {
        pie3dEchartIns.resize()
      }

      const chindMapEchartIns = this.chindMapEchartIns

      if (chindMapEchartIns) {
        chindMapEchartIns.resize()
      }

      const channelRadioPieEchartIns = this.channelRadioPieEchartIns

      if (channelRadioPieEchartIns) {
        channelRadioPieEchartIns.resize()
      }

      const gmvBarEchartIns = this.gmvBarEchartIns

      if (gmvBarEchartIns) {
        gmvBarEchartIns.resize()
      }
    }, 300)
  }

  private offEventEcharts() {
    const chindMapEchartIns = this.chindMapEchartIns

    if (chindMapEchartIns) {
      chindMapEchartIns.off('click', this.onClickChinMapEachrt)
    }

    const pie3dEchartIns = this.pie3dEchartIns

    if (pie3dEchartIns) {
      pie3dEchartIns.off('legendselectchanged', this.onPie3dChangeLegend)
    }


    window.removeEventListener('resize', this.resizeEcharts)

  }

  private created(): void {
    window.addEventListener('resize', this.resizeEcharts)
  }

  private activated() {
    this.refreshBoardInfo();
  }

  private destroyed() {
    this.offEventEcharts()
  }
}
